import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { ReactComponent as SunIcon } from '../assets/sun.svg';
import { ReactComponent as MoonIcon } from '../assets/moon.svg';

const ThemeToggleSwitch = ({ background }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label="Cambiar tema"
      style={{
        position: 'fixed',
        top: '32px',
        left: undefined,
        right: undefined,
        zIndex: 2000,
        background: background,
        border: '2px solid #fff',
        borderRadius: '999px',
        width: '72px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `${background}33 0px 4px 16px`,
        transition: 'background 0.3s',
        padding: 0,
        outline: 'none',
        cursor: 'pointer',
      }}
    >
      <span style={{
        position: 'absolute',
        left: isDarkMode ? '38px' : '6px',
        top: '6px',
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        transition: 'left 0.3s cubic-bezier(.4,2,.6,1), background 0.3s',
        zIndex: 2
      }}>
        {isDarkMode ? (
          <MoonIcon width={22} height={22} fill="#fff" />
        ) : (
          <SunIcon width={22} height={22} fill="#f9d923" />
        )}
      </span>
      {/* Fondo de iconos para referencia visual */}
      <span style={{
        position: 'absolute',
        left: '12px',
        top: '12px',
        transition: 'opacity 0.3s',
        zIndex: 1
      }}>
        <SunIcon width={16} height={16} style={{ color: '#fff' }} />
      </span>
      <span style={{
        position: 'absolute',
        right: '12px',
        top: '12px',
        transition: 'opacity 0.3s',
        zIndex: 1
      }}>
        <MoonIcon width={16} height={16} style={{ color: '#fff' }} />
      </span>
    </button>
  );
};

export default ThemeToggleSwitch; 